import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container, Underline, H3, JWTDecoder } from "../style/Customer.module";
import { Box, Button, FormControl, InputLabel, TextField } from "@mui/material";
import { gql } from "@apollo/client";
import { client } from "../../../client";
import { uploadFileWithPresignedUrl } from "../../../utils/s3Uploader";
import FileUploader from "../../admin/admin-document/FileUploader";

const StyledFormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const ErrorReport = ({ handleCloseClick }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const enumType = {
    DOWNLOAD: "DOWNLOAD",
    PAYMENT: "PAYMENT",
    REQUEST: "REQUEST",
    ETC: "ETC",
  };

  Object.freeze(enumType);

  //DecodeToken
  const userId = JWTDecoder();

  // form
  const [formData, setFormData] = useState({
    user_id: userId,
    type: enumType.DOWNLOAD,
    title: null,
    content: null,
    object_url: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    setFormData({ ...formData, [name]: updatedValue });
  };

  const handleSubmit = (objectUrl) => {
    const CREATE_ERROR_REPORT = gql`
      mutation createErrorReport(
        $user_id: Int!
        $type: reportTypeEnum!
        $title: String!
        $content: String
        $object_url: String
      ) {
        createErrorReport(
          user_id: $user_id
          type: $type
          title: $title
          content: $content
          object_url: $object_url
        ) {
          message
        }
      }
    `;

    client
      .mutate({
        mutation: CREATE_ERROR_REPORT,
        variables: {
          ...formData,
          object_url: objectUrl,
          user_id: userId,
        },
      })
      .then((res) => {
        alert("오류 제보가 성공적으로 등록되었습니다.");
        if (handleCloseClick) handleCloseClick();
      })
      .catch((err) => {
        alert(`오류 제보 등록 중 오류가 발생했습니다. ${err.message}`);
        console.error(err);
      });
  };

  const handleUploadAndSubmit = async () => {
    if (!formData.title || !formData.content) {
      alert("제목과 내용을 입력해주세요.");
      return;
    }

    setIsLoading(true);
    try {
      let finalObjectUrl = null;

      if (selectedFile) {
        finalObjectUrl = await uploadFileWithPresignedUrl(client, selectedFile);
      }

      handleSubmit(finalObjectUrl);
    } catch (err) {
      alert(`업로드 중 오류가 발생했습니다: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelButton = () => (window.location.href = "/customer/records");

  return (
    <Container>
      <H3>오류제보</H3>
      <Underline></Underline>
      <StyledFormContainer>
        <form>
          <FormControl>
            <InputLabel id="title"></InputLabel>
            <TextField
              label="제목"
              name="title"
              defaultValue={formData.title}
              onChange={handleChange}
              sx={{ marginBottom: 2, width: "400px" }}
            ></TextField>
          </FormControl>
          <FormControl>
            <InputLabel id="content"></InputLabel>
            <TextField
              label="내용"
              name="content"
              multiline
              rows={10}
              defaultValue={formData.content}
              onChange={handleChange}
              sx={{ marginBottom: 2, width: "400px" }}
            ></TextField>
          </FormControl>

          <FileUploader
            selectedFiles={selectedFile ? [selectedFile] : []}
            setSelectedFiles={(files) => setSelectedFile(files[0] || null)}
          />

          <Button
            variant="contained"
            fullWidth
            onClick={handleUploadAndSubmit}
            disabled={isLoading}
            sx={{ mt: 2 }}
          >
            {isLoading ? "제출 중..." : "오류 제보하기"}
          </Button>

          <Button sx={{ marginTop: "15px" }} onClick={() => cancelButton()}>
            취소
          </Button>
        </form>
      </StyledFormContainer>
    </Container>
  );
};

export default ErrorReport;
